import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { createInternationalFundingAccountHandler } from 'actions/routines/funding';
import { formNamesFunding } from 'constants/forms';
import { sidePanelNameManuallyAddBankAccount } from 'constants/sidePanels';
import {} from 'interfaces/global';
import { makeFormSubmitFailHandler } from 'modules/createPartnerCompany/helpers/submitFailure';
import { companyFromQuerySelector } from 'queries/companyCompoundSelectors';
import { fundingAccountsForCompanyIdQuerySelector, manuallyAddBankAccountFormInitialValuesSelector, } from 'queries/fundingCompoundSelectors';
import { itemCurrencyCodeReceiverFromQuerySelector } from 'queries/itemRouterSelectors';
import { partnershipFromCurrentPartnershipRequestSelector, partnershipPartnerCompanyFromPartnershipRequestSelector, } from 'queries/partnershipCompoundSelectors';
import { manuallyAddBankAccountFormIsValidSelector } from 'selectors/forms';
import { fundingAccountBankManualErrorsSelector } from 'selectors/fundingSelectors';
import { createSidePanelSelector } from 'selectors/sidePanelsSelector';
import ManuallyAddBankAccountSideSheet from './ManuallyAddBankAccountSideSheet';
import {} from './ManuallyAddBankAccountSideSheet.types';
const formName = formNamesFunding.ADD_MANUAL_BANK;
const manuallyAddBankAccountSidePanelSelector = createSidePanelSelector(sidePanelNameManuallyAddBankAccount);
export const mapStateToProps = createStructuredSelector({
    company: companyFromQuerySelector,
    errors: fundingAccountBankManualErrorsSelector,
    fundingAccounts: fundingAccountsForCompanyIdQuerySelector,
    initialValues: manuallyAddBankAccountFormInitialValuesSelector,
    isFormValid: manuallyAddBankAccountFormIsValidSelector,
    itemCurrencyCodeReceiver: itemCurrencyCodeReceiverFromQuerySelector,
    partnerCompany: partnershipPartnerCompanyFromPartnershipRequestSelector,
    partnership: partnershipFromCurrentPartnershipRequestSelector,
    sidePanel: manuallyAddBankAccountSidePanelSelector,
});
const createManuallyAddBankAccountForm = reduxForm({
    destroyOnUnmount: true,
    form: formName,
    onSubmit: createInternationalFundingAccountHandler,
    onSubmitFail: makeFormSubmitFailHandler(formName),
})(ManuallyAddBankAccountSideSheet);
export default connect(mapStateToProps)(createManuallyAddBankAccountForm);
